import * as React from 'react'
import Fees from '../presentations/Fees'

export class FeesContainer extends React.Component<FeesContainerProps, FeesContainerState> {
  constructor(props: FeesContainerProps) {
    super(props)
  }
  public render() {
    return (
      <div style = {Object.assign({}, this.props.containerStyle)}>
        <h2> {this.props.header} </h2>
        <Fees
          accountId={this.props.accountId}
          marketplaceId={this.props.marketplaceId}
          accountCategoryId={this.props.accountCategoryId || (window as any).md3.account.getActive().categoryId}
          feeView= {this.props.feeView}
          metals={this.props.metals || (window as any).md3.metal.filter()}
          cancelActionFn={this.props.cancelActionFn}
          feeUpdateFn={this.props.feeUpdateFn}
          readOnly = {this.props.readOnly}
          />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./react/components/containers/FeesContainer.tsx